import type { MatrixBackend } from '~/composables/matrix/useMatrixController'

const ExampleMatrix: MatrixBackend = {
  equipments: [
    {
      name: 'Betriebsmittel 1',
      included: true,
    },
    {
      name: 'Betriebsmittel 2',
      included: true,
    },
    {
      name: 'Betriebsmittel 3',
      included: true,
    },
  ],
  topologies: [
    {
      name: 'Topologie 1',
      included: true,
      full_year: true,
      start_date: null,
      end_date: null,
      equipments: [
        true,
        true,
        true,
      ],
    },
    {
      name: 'Topologie 2',
      included: true,
      full_year: true,
      start_date: null,
      end_date: null,
      equipments: [
        false,
        false,
        false,
      ],
    },
    {
      name: 'Topologie 3',
      included: true,
      full_year: true,
      start_date: null,
      end_date: null,
      equipments: [
        false,
        true,
        true,
      ],
    },
    {
      name: 'Topologie 4',
      included: true,
      full_year: true,
      start_date: null,
      end_date: null,
      equipments: [
        false,
        false,
        true,
      ],
    },
  ],
}

export default ExampleMatrix
